'use client'

import { BreadcrumbsDS } from '@src/components/blocks/breadcrumb-ds'

import type { BreadCrumbProps } from './bread-crumb.types'
import type { ComponentProps } from 'react'

type DSBreadcrumbsProps = ComponentProps<typeof BreadcrumbsDS>

/** Thin atom-layer wrapper around design-system `BreadcrumbsDS`. */
export function BreadCrumbDS(props: BreadCrumbProps) {
  return <BreadcrumbsDS {...(props as DSBreadcrumbsProps)} />
}
